"use strict";

import initModulesInScope from "@elements/init-modules-in-scope";

export function initInScope ($scope) {
    let pendingRequest = null;

    $scope.find('.js-change-product__input').on('change', function (e) {
        e.preventDefault();


        let $container = $(this).closest('.js-change-product'),
            $loading = $container.find('.js-change-product__loading'),
            $error = $container.find('.js-change-product__error'),
            $result = $container.find('.js-change-product__result'),
            pushInHistory = $container.data('change-product-in-history')||false;

        if (pendingRequest) {
            pendingRequest.abort();
            pendingRequest = null;
        }

        let $this = $(this);
        let $form = $(this).closest('form');
        let ajaxUrl = $form.data('ajax-product-change-url');
        let data = $form.serialize();

        $result.attr('hidden', null);
        $loading.attr('hidden', null);

        pendingRequest = $.ajax(ajaxUrl, {
            dataType: 'json',
            data: data,
            cache: true
        }).done(function (response) {
            if (response.content){
                $result.empty().append(response.content);
                let href = $this.closest('.js-change-product__item').data('product-change-href');

                if (pushInHistory){
                    history.replaceState({}, '', window.location.origin + href);
                }

                initModulesInScope($result);
            }


        }).fail(function (jqXHR, textStatus, errorThrown) {
            if (textStatus !== 'abort') {
                $error.attr('hidden', null);
                console.error(textStatus, errorThrown, jqXHR);
            }
        }).always(function () {
            $loading.attr('hidden', 'hidden');
            pendingRequest = null;
        });

    });
    
}
